import Image from 'next/image';

export default function Logo(props) {
  return (
    <Image
      src="/images/logo.png"
      alt="corporatieNL logo"
      width={props.width ? props.width : 210}
      height={props.height ? props.height : 31.39}
    />
  );
}
